import LandingSectionHeader from "./LandingSectionHeader";
import { CREATION_FORMATS } from "./landingCreationFormats";
import "./LandingCreationSection.css";

export default function LandingCreationSection() {
  return (
    <>
      {CREATION_FORMATS.map((format, index) => (
        <section
          key={format.id}
          id={index === 0 ? "create" : format.sectionId}
          className={`landing-band ${format.bandClass} landing-section landing-section--creation`}
        >
          <div className="landing-container">
            <LandingSectionHeader
              label={format.label}
              title={format.title}
              desc={format.sectionDesc}
            />

            <div className={`landing-band__panel ${format.panelClass}`}>
              <div className="landing-create-single">
                <div className="landing-create-single__info">
                  <div className="landing-create-single__head">
                    <span className="landing-create-card__tag">{format.tag}</span>
                    <div className="landing-create-card__icon">{format.icon}</div>
                    <p className="landing-create-single__desc">{format.desc}</p>
                  </div>

                  <ol className="landing-create-card__steps landing-create-single__steps">
                    {format.steps.map((step) => (
                      <li key={step}>{step}</li>
                    ))}
                  </ol>
                </div>

                <div className="landing-create-single__previews">
                  <div className="landing-create-card__preview">
                    <span className="landing-create-card__preview-label">
                      {format.editorLabel}
                    </span>
                    {format.editor}
                  </div>
                  <div className="landing-create-card__preview">
                    <span className="landing-create-card__preview-label">
                      {format.resultLabel}
                    </span>
                    {format.bot}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      ))}
    </>
  );
}
